import React from "react";
import type { UploadProps } from "antd";
import { Upload } from "antd";
import styled from "styled-components";
import { UploadOutlined } from "@ant-design/icons";
// import { IColorScheme } from "ui/utils";

const { Dragger } = Upload;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: auto;
  width: 100%;
`;
const Text = styled.span``;
// color: ${({ theme: { colors } }) => (colors as IColorScheme).accent};
const Hint = styled.p`
  width: 50%;

  font-family: "Satoshi";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 160%;
  width: 100%;
`;
export interface FileDragProps {
  dragProps: UploadProps;
  text: React.ReactNode;
  hint: React.ReactNode;
}
export const FileDragIn: React.FC<FileDragProps> = ({
  dragProps,
  text,
  hint,
}) => (
  <Dragger {...dragProps}>
    <Content>
      <div className="ant-upload-drag-icon">{<UploadOutlined />}</div>
      <Hint className="ant-upload-hint">
        <Text className="ant-upload-text">{text} </Text>
        {hint}
      </Hint>
    </Content>
  </Dragger>
);
